import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import CustomerLayout from "../CustomerLayout";

const CustomerCourierCommunication = () => {
  const [openMessage, setOpenMessage] = useState(false);

  return (
    <CustomerLayout>
      <Box sx={{ maxWidth: 900, mx: "auto", py: { xs: 2, md: 4 } }}>
        <Box sx={{ textAlign: "center", mb: 4, px: { xs: 1, sm: 0 } }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              letterSpacing: "-0.02em",
              mb: 1,
            }}
          >
            Driver Communication
          </Typography>

          <Typography
            sx={{
              color: "text.secondary",
              fontSize: "1rem",
              lineHeight: 1.6,
              maxWidth: 720,
              mx: "auto",
            }}
          >
            Communicate directly with assigned drivers regarding pickups, load
            status, and transportation updates.
          </Typography>
        </Box>

        <Paper
          elevation={0}
          sx={{
            border: "1px solid #e5e7eb",
            borderRadius: 3,
            p: { xs: 2.5, sm: 4 },
            boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, minmax(0, 1fr))",
              },
              gap: 2,
              width: "100%",
              maxWidth: { xs: 320, sm: 640 },
              mx: "auto",
            }}
          >
            <Button
              variant="contained"
              size="large"
              onClick={() => setOpenMessage(true)}
              sx={{
                py: 1.25,
                width: "100%",
                textTransform: "none",
                fontWeight: 700,
              }}
            >
              Send Message
            </Button>

            <Button
              variant="outlined"
              size="large"
              href="tel:+18001234567"
              sx={{
                py: 1.25,
                width: "100%",
                textTransform: "none",
                fontWeight: 700,
              }}
            >
              Call Driver
            </Button>
          </Box>
        </Paper>

        <Dialog
          open={openMessage}
          onClose={() => setOpenMessage(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Message Driver</DialogTitle>

          <DialogContent dividers>
            <TextField
              fullWidth
              multiline
              rows={5}
              placeholder="Type your message..."
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenMessage(false)}>Cancel</Button>

            <Button variant="contained" onClick={() => setOpenMessage(false)}>
              Send Message
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </CustomerLayout>
  );
};

export default CustomerCourierCommunication;